import { Link } from "react-router-dom";

export const ContactConfirm = () => {
  return (
    <>
      <div className="pageHero">
        <div className="pageHeroText">
          <h1 className="pageHeroTitle">Message Received</h1>
          <p className="pageHeroSubtitle">
            Thank you for reaching out. We will get back to you as soon as possible.
          </p>
        </div>
      </div>

      <div className="pageContent">

        <div className="serviceSection" style={{ textAlign: "center" }}>
          <div style={{ fontSize: "3rem", marginBottom: "16px" }}>&#10003;</div>
          <h3 className="sectionTitle" style={{ textAlign: "center", borderBottom: "none", paddingBottom: 0 }}>
            Your message is on its way
          </h3>
          <p style={{ maxWidth: "560px", margin: "12px auto 28px", textAlign: "center" }}>
            A real person — not a bot — will review your message and respond as soon as possible.
            In the meantime, feel free to explore what we offer.
          </p>
          <div style={{ display: "flex", gap: "16px", justifyContent: "center", flexWrap: "wrap" }}>
            <Link to="/" className="calloutCta" style={{ textDecoration: "none" }}>Go to Home</Link>
            <Link to="/Services" className="calloutCta" style={{ textDecoration: "none" }}>Explore Services</Link>
          </div>
        </div>

      </div>
    </>
  );
};
